'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_ui_qrcode_QrCode$$anon$1(host$3, outer) {
  this.cfX = null;
  this.cfX = host$3;
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
}
export { $c_Lpresto_ui_qrcode_QrCode$$anon$1 as $c_Lpresto_ui_qrcode_QrCode$$anon$1 };
$p = $c_Lpresto_ui_qrcode_QrCode$$anon$1.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_sr_AbstractPartialFunction();
$p.constructor = $c_Lpresto_ui_qrcode_QrCode$$anon$1;
/** @constructor */
function $h_Lpresto_ui_qrcode_QrCode$$anon$1() {
}
export { $h_Lpresto_ui_qrcode_QrCode$$anon$1 as $h_Lpresto_ui_qrcode_QrCode$$anon$1 };
$h_Lpresto_ui_qrcode_QrCode$$anon$1.prototype = $p;
$p.id = (function(x) {
  return true;
});
$p.i9 = (function(x, default$1) {
  return document.body.removeChild(this.cfX);
});
$p.cb = (function(x) {
  return this.id(x);
});
$p.bk = (function(x, default$1) {
  return this.i9(x, default$1);
});
var $d_Lpresto_ui_qrcode_QrCode$$anon$1 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_ui_qrcode_QrCode$$anon$1, "presto.ui.qrcode.QrCode$$anon$1", ({
  a4F: 1,
  a4: 1,
  t: 1,
  A: 1,
  a: 1
}));
export { $d_Lpresto_ui_qrcode_QrCode$$anon$1 as $d_Lpresto_ui_qrcode_QrCode$$anon$1 };
//# sourceMappingURL=presto.ui.qrcode.-Qr-Code$$anon$1.js.map
